export enum FeedEntryType {
  FOLLOWING = 'FOLLOWING', // Shows in feed because user follows author
  RECOMMENDED = 'RECOMMENDED', // Algorithmic recommendation
  REPLY_NOTIFICATION = 'REPLY_NOTIFICATION', // Someone replied to user's post
  LIKED = 'LIKED', // Shows because user liked the post
  BOOKMARKED = 'BOOKMARKED', // Shows because user bookmarked it
  MENTION = 'MENTION', // User was @mentioned in the post
  QUOTED = 'QUOTED', // User's post was quoted/referenced
  TRENDING = 'TRENDING', // Post is trending in user's network/region
  MUTUAL_INTERACTION = 'MUTUAL_INTERACTION', // Multiple mutual follows engaged with it
  AUTHORED = 'AUTHORED',
  CATEGORY_INTEREST = 'CATEGORY_INTEREST',
}
